<template>
  <v-card class="elevation-0 mx-8 pa-2">
    <v-card-title>
        Planes Alimenticios
        <v-spacer></v-spacer>
        <!--v-text-field
        @keydown.enter="getDataFromApi()"
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar por Paciente"
        single-line
        hide-details
        class="mb-6 mx-4"
    ></v-text-field-->
        
    </v-card-title>
    
    <v-data-table
        :items="plans" 
        :headers="header"
        :footer-props="{'items-per-page-options':[15, 30, 50, totalPlans]}"
        :options.sync="options"
        :server-items-length="totalPlans"
        :loading="loading"
    >
        <template v-slot:[`item.file_path`]="{ item }">
            <v-btn v-if="item.file_path!=undefined" v-bind:href="item.file_path" target="_blank" icon>
                <v-icon small>mdi-file</v-icon>
            </v-btn>
        </template>
    </v-data-table>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>

    <!-- Crear actividad -->
    <v-dialog v-model="createDialog" max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn bottom color="#e12826" dark fab fixed right v-bind="attrs" v-on="on">
            <v-icon color="white">  mdi-plus </v-icon>
        </v-btn> 
      </template>
      <create @closeCreateDialog="closeCreateDialog"/>
    </v-dialog>

  </v-card>
</template>

<script>
import Create from './create.vue'
import axios from "axios"
  export default {
    components:{
      'create': Create  
    },
    data () {
      return {
        createDialog:false,
        totalPlans: 0,
        plans: [],
        loading: true,
        options: {},
        activeSearch: false,
        search: '',
        header: [
            {text:'Plan Alimenticio', value:'name'},
            {text:'Paciente', value:'user'},
            {text:'PDF', value:'file_path'},
            {text:'Notas', value:'note'},
        ],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
      }
    },
    watch: {
        options: {
            handler () {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods:{
        getDataFromApi () {
            this.loading = true
            this.apiCall().then(data => {
                this.plans = data.plans
                this.totalPlans = data.total
                this.loading = false
            })
        },
        apiCall () {
            return new Promise((resolve, reject) => {
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                var plans = []
                var total = 0
                var link = ''
                if(sortBy.length === 1){
                    if(sortDesc[0]){
                        link = link + "sort=-" + sortBy[0] + '&'
                    }else{
                        link = link + "sort=" + sortBy[0] + '&'
                    }
                }
                /*if(this.search!=''){
                    link = link + 'filter[user.name]=' + this.search + '&'
                }*/
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/meal_plans?" + link + "page=" + page + "&itemsPerPage=" + itemsPerPage + '&filter[user.id]=' + this.$route.params.id).then(response => {
                    plans = this.mapPlans(response.data.data)
                    total = total = response.data.meta.total
                    resolve({
                        plans,
                        total,
                    })
                })
            })
        },
        mapPlans(items){
            return items.map(id=>{return{
                id:id.id,
                user:id.user.name,
                file_path:id.file_path,
                name:id.name,
                json:id.json,
                note:id.note
            }})
        },
        closeCreateDialog: function(params){
            this.getDataFromApi()
            this.createDialog = params
        }
    }
}
</script>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>